import React, { useState, useMemo } from "react"
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from "@date-io/date-fns";
import { Box, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import { DatePicker } from '@material-ui/pickers';
import Format from "date-fns/format";
import { useAuthUser } from "../../../hooks/useUserToken";
import { useEffect } from "react";
import axios from 'axios';
import { ReportingService, TransportService } from "../../../utils/web_config_2";
import { LoadingScreen } from "../atoms/loading-card";

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up("sm")]: {
			marginLeft: 250,
		},
	},
}));

const TableView = ({ loading = false, data, startDate, endDate }) => {
	if (loading) return <LoadingScreen />;

  return (
    <>
			<Card>
				<MUIDataTable
					title={
						<div>
							From: {startDate.value} to {endDate.value}
						</div>
					}
					data={data}
					columns={[
							"actual_ticket_amount",
							"arrival_haour",
							"names",
							"arrival_time",
							"booking_number",
							"bus_type",
							"channel_type",
							"currency",
							"device_account_number",
							"device_number",
							"first_amount_due",
							"generated_at",
							"ticket_number",
							"ticket_type",
							"transaction_mode",
					]}
					options={{
						filterType: "checkbox",
					}}
				/>
			</Card>
		</>
  )
}

export default function InvalidAndVoidedTickets(){
	const [isLoading, setIsLoading] = useState(false);

  const styles = useStyles();

  const [showFilterDialog, setShowFilterDialog] = useState(false)
  const [reportLoad, setReportLoad] = useState(false)
	const [data, setData] = useState([])

  const [startDate, setStartDate] = useState({
		value: Format(new Date(), ["yyyy-MM-dd"]),
		error: "",
	});
  const [endDate, setEndDate] = useState({
		value: Format(new Date(), ["yyyy-MM-dd"]),
		error: "",
	});

	const { token, organization } = useAuthUser();

  const filter_report = async () => {
		setIsLoading(true)
		setReportLoad(true)

		try {
			axios.defaults.baseURL = new TransportService().BASE_URL;
			const reportInstance = axios.create(
				new TransportService().setHeaders(token)
			);
	
			let {
				data: { data: tickets },
			} = await reportInstance.post("/api/v1/ticketing/pullInvalidAndVoided",
				{
					"from_date": startDate.value+" 00:00:00",
					"to_date": endDate.value+" 23:59:59",
  				"operator_id": organization.organization_id
				}
			);
			setIsLoading(false);
			setData(tickets)
		} catch (error) {
			console.log(error.response.data.data)
			setData(error.response.data.data)

			setIsLoading(false);
		}
		setShowFilterDialog(false)
		setReportLoad(false)
  }

	useEffect(() => {
		filter_report();
	}, [])

	let formattedData = useMemo(() => {
		let returnable = [];
		for(let item of data){
			returnable.push([
				item.actual_ticket_amount,
				item.arrival_haour,
				item.names,
				item.arrival_time,
				item.booking_number,
				item.bus_type,
				item.channel_type,
				item.currency,
				item.device_account_number,
				item.device_number,
				item.first_amount_due,
				item.generated_at,
				item.ticket_number,
				item.ticket_type,
				item.transaction_mode,
			])
		}

		return returnable;
	}, [data])

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div>
				<div className={styles.root}>
					<Box
						display={"flex"}
						justifyContent={"space-between"}
						paddingBottom={"40px"}
					>
						<Typography variant="h5" color="default">
							<b>
								Invalid and Voided Tickets
							</b>
						</Typography>

						<Button
							onClick={() => setShowFilterDialog(true)}
							color="primary"
							variant="contained"
						>
							Filter
						</Button>
					</Box>

          <TableView loading={isLoading} data={formattedData} startDate={startDate} endDate={endDate}/>
				</div>

				<Dialog
					maxWidth="sm"
					fullWidth
					open={showFilterDialog}
					onClose={() => {
						setShowFilterDialog(false);
					}}
					aria-labelledby="filter"
					aria-describedby="filter"
				>
					<DialogTitle id="filter">{"Filter"}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							<Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant="inline"
										format="yyyy-MM-dd"
										margin="dense"
										autoOk
										label="Start date"
										value={startDate.value}
										inputVariant="outlined"
										onChange={(v) => {
											console.log("choosen1: ", Format(v, ["yyyy-MM-dd"]));

											setStartDate({
												value: Format(v, ["yyyy-MM-dd"]),
												error: "",
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
								<Box mt={1}>
									<DatePicker
										fullWidth
										disableToolbar
										variant="inline"
										format="yyyy-MM-dd"
										margin="dense"
										autoOk
										label="End date"
										value={endDate.value}
										inputVariant="outlined"
										onChange={(v) => {
											console.log("choosen2: ", v);
											setEndDate({
												value: Format(v, ["yyyy-MM-dd"]),
												error: "",
											});
										}}
										InputProps={{
											disableUnderline: true,
											style: { paddingRight: 0 },
										}}
									/>
								</Box>
							</Box>
						</DialogContentText>
					</DialogContent>

					<DialogActions>
						<Button
							onClick={() => {
								setShowFilterDialog(false);
							}}
							color="secondary"
						>
							<Typography>Close</Typography>
						</Button>

						<Button
							onClick={() => {
								filter_report();
							}}
							color="primary"
							variant="contained"
						>
							{reportLoad ? (
								<CircularProgress size={25} color="secondary" />
							) : (
								<Typography>View</Typography>
							)}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</MuiPickersUtilsProvider>
  )
}